import { render } from "./DigitalProducts.vue.js?vue&type=template&id=14fbc1dc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProducts.vue?vue&type=template&id=14fbc1dc"
import script from "./DigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProducts.vue?vue&type=script&lang=js"
export * from "./DigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/DigitalProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14fbc1dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14fbc1dc', __exports__)) {
    api.reload('14fbc1dc', __exports__)
  }
  
  module.hot.accept("./DigitalProducts.vue.js?vue&type=template&id=14fbc1dc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProducts.vue?vue&type=template&id=14fbc1dc", () => {
    api.rerender('14fbc1dc', render)
  })

}


export default __exports__